import { render } from "./Page.vue?vue&type=template&id=09512f3f&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=09512f3f&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09512f3f"],['__file',"src/components/Page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09512f3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09512f3f', __exports__)) {
    console.log('reload')
    api.reload('09512f3f', __exports__)
  }
  
  module.hot.accept("./Page.vue?vue&type=template&id=09512f3f&scoped=true", () => {
    console.log('re-render')
    api.rerender('09512f3f', render)
  })

}


export default __exports__